function getFilterObject(params) {
  return params.reduce(
    (obj, item) =>
      Object.assign(obj, {
        [item?.column?.column]: item?.value?.code || item.value,
      }),
    {}
  );
}

export { getFilterObject };
